import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl font-heading font-bold text-white">
                韩漫大全
              </span>
              <span className="text-xs bg-primary-500 text-white px-2 py-0.5 rounded-full">
                无删减
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              韩国漫画无删减漫画下拉式免费韩漫大全，资源丰富多元，更新速度快，让您第一时间感受韩漫魅力。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                <span>contact@manhuadaquan.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                <span>在线客服：7×24小时</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                <span>正版授权 · 安全阅读</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 韩漫大全. All rights reserved. 本站所有漫画均获正版授权。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer" rel="nofollow">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}